import { bindActionCreators as bindActions } from "redux";
import { connect } from "react-redux";

import { intlCityAction } from "../modules/intl";
import { getCities } from "../selectors";
import CityScreen from "./CityScreen";

const state = (state) => ({
  cityId: state.intl.cityId,
  cities: getCities(state),
});

const actions = (dispatch) =>
  bindActions(
    {
      setCity: intlCityAction,
    },
    dispatch
  );

export default connect(
  state,
  actions
)(CityScreen);
